<template>
    <v-breadcrumbs v-if="isMobile" :items="prevBreadcrumb">
        <template v-slot:item="{ item }">
            <v-breadcrumbs-item
                exact
                :to="item.to"
                :disabled="item.disabled"
            >
                <v-icon>mdi-chevron-left</v-icon>{{ item.text }}
            </v-breadcrumbs-item>
        </template>
    </v-breadcrumbs>
    <v-breadcrumbs v-else-if="breadcrumbsCount" :items="breadcrumbs">
        <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
        </template>
        <template v-slot:item="{ item }">
            <v-breadcrumbs-item
                exact
                :to="item.to"
                :disabled="item.disabled"
            >
                {{ $t(item.text) }}
            </v-breadcrumbs-item>
        </template>
    </v-breadcrumbs>
</template>

<script>
    export default {
        name: "Breadcrumbs",

        computed: {
            isMobile() {
                return this.$vuetify.breakpoint.mobile;
            },
            breadcrumbs() {
                return this.$route.meta.breadcrumbs || [];
            },
            breadcrumbsCount() {
                return this.breadcrumbs.length;
            },
            prevBreadcrumb() {
                return this.breadcrumbsCount > 1 ? [this.breadcrumbs[this.breadcrumbsCount-2]] : [];
            },
        },
    }
</script>

<style scoped>

</style>
